import React, { useEffect, useState, useRef } from "react";
import api from "../../api/api";
import "../../css/Employee.css";

const AppId = () => {
  const [employees, setEmployees] = useState([]);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [employeesPerPage, setEmployeesPerPage] = useState(10);
  const [showListFilter, setShowListFilter] = useState(false);

  const listFilterRef = useRef(null);

  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("all");

  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState("all");

  // Fetch employees
  useEffect(() => {
    api
      .get("/employee/list")
      .then((response) => {
        if (response.data.success) {
          setEmployees(response.data.data);
          setFilteredEmployees(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching employees:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  // Fetch companies
  useEffect(() => {
    api
      .get("/get/company")
      .then((response) => {
        if (response.data.success) {
          setCompanies(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching companies:", error);
      });
  }, []);

  // Fetch states
  useEffect(() => {
    api
      .get("/get/state")
      .then((response) => {
        if (response.data.success) {
          setStates(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching states:", error);
      });
  }, []);

  // Filtering logic
  useEffect(() => {
    let filtered = employees;

    if (selectedCompany !== "all") {
      filtered = filtered.filter((emp) => emp.company_name === selectedCompany);
    }

    if (selectedState !== "all") {
      filtered = filtered.filter((emp) => emp.state === selectedState);
    }

    filtered = filtered.filter(
      (emp) =>
        `${emp.firstname || ""} ${emp.lastname || ""}`
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        (emp.username || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (emp.email || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (emp.phone || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (emp.company_name || "")
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        (emp.department_name || "")
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        (emp.designation_name || "")
          .toLowerCase()
          .includes(searchTerm.toLowerCase()) ||
        (emp.state || "").toLowerCase().includes(searchTerm.toLowerCase())
    );

    setFilteredEmployees(filtered);
    setCurrentPage(1);
  }, [searchTerm, employees, selectedCompany, selectedState]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        listFilterRef.current &&
        !listFilterRef.current.contains(event.target)
      ) {
        setShowListFilter(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handlePerPageChange = (value) => {
    setEmployeesPerPage(value);
    setShowListFilter(false);
    setCurrentPage(1);
  };

  const indexOfLastEmployee = currentPage * employeesPerPage;
  const indexOfFirstEmployee = indexOfLastEmployee - employeesPerPage;
  const currentEmployees = filteredEmployees.slice(
    indexOfFirstEmployee,
    indexOfLastEmployee
  );
  const totalPages = Math.ceil(filteredEmployees.length / employeesPerPage);

  const handleDelete = (emp) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to remove deviceId for ${emp.firstname} ${emp.lastname}?`
    );
    if (confirmDelete) {
      api
        .post("/deviceId/remove", { user_id: emp.emp_id })
        .then((response) => {
          if (response.data.success) {
            alert("Device ID removed successfully!");

            // Re-fetch updated employee list
            api
              .get("/employee/list")
              .then((res) => {
                if (res.data.success) {
                  setEmployees(res.data.data);
                  setFilteredEmployees(res.data.data);
                }
              })
              .catch((err) => {
                console.error("Error re-fetching employees:", err);
                alert("Error fetching updated employee list.");
              });
          } else {
            alert("Failed to remove device ID. Please try again.");
          }
        })
        .catch((error) => {
          console.error("Error removing device ID:", error);
          alert("An error occurred while removing device ID.");
        });
    }
  };

  return (
    <section className="employee-section">
      <div className="inner-content">
        <div className="filter-wrapper">
          <h2>Employee List</h2>
          <div className="right-filter">
            <div className="search-bar">
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div
              className="select-company tooltip-wrapper"
              data-tooltip="Filter by Company"
            >
              <select
                value={selectedCompany}
                onChange={(e) => setSelectedCompany(e.target.value)}
              >
                <option value="all">All Companies</option>
                {companies.map((company) => (
                  <option key={company.id} value={company.name}>
                    {company.name}
                  </option>
                ))}
              </select>
            </div>
            <div
              className="state-select tooltip-wrapper"
              data-tooltip="Filter by State"
            >
              <select
                value={selectedState}
                onChange={(e) => setSelectedState(e.target.value)}
              >
                <option value="all">All States</option>
                {states.map((state) => (
                  <option key={state.state_id} value={state.state_title}>
                    {state.state_title}
                  </option>
                ))}
              </select>
            </div>

            <div
              className="list-fliter  tooltip-wrapper"
              ref={listFilterRef}
              data-tooltip="Filter by List"
            >
              <button onClick={() => setShowListFilter(!showListFilter)}>
                <i className="fa-solid fa-filter"></i>
              </button>
              {showListFilter && (
                <div className="filter-data">
                  {[10, 30, 50, 100].map((number) => (
                    <div
                      key={number}
                      className={`filter-option ${
                        employeesPerPage === number ? "selected" : ""
                      }`}
                      onClick={() => handlePerPageChange(number)}
                    >
                      {number}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
        {loading ? (
          <p>Loading...</p>
        ) : (
          <>
            <div className="table-wrapper">
              <table className="employee-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>device_id</th>
                    <th>Full Name</th>
                    <th>Phone</th>
                    <th>Company</th>
                    <th>Department</th>
                    <th>Designation</th>
                    <th>State</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                 {currentEmployees.map((emp, index) => (
  <tr
    key={emp.emp_id}
    className={emp.device_id === null ? "no-device" : ""}
  >
    <td>{indexOfFirstEmployee + index + 1}</td>
    <td className="check-in">{emp.device_id ? emp.device_id : "N/A"}</td>
    <td>
      {emp.firstname} {emp.lastname}
    </td>
    <td className="phone">
      <i className="fa-solid fa-phone"></i>&nbsp; {emp.phone}
    </td>
    <td className="p-day">{emp.company_name}</td>
    <td>{emp.department_name}</td>
    <td>{emp.designation_name}</td>
    <td className="state">{emp.state}</td>
    <td>
      <div className="auction-btns">
        <button
  onClick={() => handleDelete(emp)}
  className="action-btn delete"
  disabled={!emp.device_id} // Disable if device_id is null/empty
>
  <i className="fa-solid fa-trash"></i>
</button>

      </div>
    </td>
  </tr>
))}

                </tbody>
              </table>
            </div>
            <div className="pagination">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Prev
              </button>
              <span>
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default AppId;
